var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66699 13.334C1.66699 10.9773 1.66699 9.79815 2.39949 9.06648C3.13116 8.33398 4.31033 8.33398 6.66699 8.33398H13.3337C15.6903 8.33398 16.8695 8.33398 17.6012 9.06648C18.3337 9.79815 18.3337 10.9773 18.3337 13.334C18.3337 15.6907 18.3337 16.8698 17.6012 17.6015C16.8695 18.334 15.6903 18.334 13.3337 18.334H6.66699C4.31033 18.334 3.13116 18.334 2.39949 17.6015C1.66699 16.8698 1.66699 15.6907 1.66699 13.334Z",
    stroke: "#909090"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 8.33366V6.66699C5 5.34091 5.52678 4.06914 6.46447 3.13146C7.40215 2.19378 8.67392 1.66699 10 1.66699C11.3261 1.66699 12.5979 2.19378 13.5355 3.13146C14.4732 4.06914 15 5.34091 15 6.66699V8.33366",
    stroke: "#909090",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66699 13.334H6.67449M9.99283 13.334H10.0003M13.3262 13.334H13.3337",
    stroke: "#909090",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.5e1d9eb80a31af1c2a3b5a362616e619.svg";
export { ForwardRef as ReactComponent };